import { computed, inject, Injectable, Injector, signal } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";
import { WorkflowDraftConfirmationService } from "./workflow-draft-confirmation.service";

@Injectable({ providedIn: "root" })
export class WorkflowDraftDirtyStateService {
  private readonly injector = inject(Injector);
  private readonly dirtyState = signal(false);
  private readonly operationInProgressState = signal(false);

  readonly isDirty = this.dirtyState.asReadonly();
  readonly isOperationInProgress = this.operationInProgressState.asReadonly();
  readonly isNavigationBlocked = computed(() =>
    this.dirtyState() || this.operationInProgressState());

  setDirty(isDirty: boolean): void {
    this.dirtyState.set(isDirty);
  }

  setOperationInProgress(isInProgress: boolean): void {
    this.operationInProgressState.set(isInProgress);
  }

  confirmNavigation(): boolean | Promise<boolean> {
    if (this.operationInProgressState()) {
      return false;
    }

    if (!this.dirtyState()) {
      return true;
    }

    return this.injector.get(WorkflowDraftConfirmationService).confirm({
      heading: "Leave draft editor?",
      message: "Unsaved workflow draft changes will be lost if you leave this page.",
      confirmText: "Leave without saving",
      cancelText: "Stay on page",
    });
  }
}

export const workflowDraftUnsavedChangesGuard: CanDeactivateFn<unknown> = () =>
  inject(WorkflowDraftDirtyStateService).confirmNavigation();
